import { createContext, useContext, useEffect, useState } from 'react'
import { primaryEventBus, PrimaryEvents } from 'v2/utils/event-bus/primary'

const PrimaryContext = createContext<boolean>(false)

export const usePrimary = () => useContext(PrimaryContext)

export interface PrimaryProviderProps {
  children: React.ReactNode
}

export const PrimaryProvider = ({ children }: PrimaryProviderProps) => {
  const [isPrimary, setIsPrimary] = useState(false)

  useEffect(() => {
    const unsubscribe = primaryEventBus.on(PrimaryEvents.PRIMARY_TAB_STATUS, setIsPrimary)
    return () => unsubscribe()
  }, [])

  return <PrimaryContext.Provider value={isPrimary}>{children}</PrimaryContext.Provider>
}
